(function() {
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-firefly-about-hero]'));
  if (!roots.length || !window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  roots.forEach(function(root, rootIndex) {
    var scene = root.querySelector('[data-about-scene]');
    var canvas = root.querySelector('[data-about-canvas]');
    var intro = root.querySelector('[data-about-intro]');
    var stages = Array.prototype.slice.call(root.querySelectorAll('[data-about-stage]'));
    if (!scene || !canvas || !intro) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      gsap.set(stages, { autoAlpha: 0 });
      return;
    }

    var videoButton = root.querySelector('[data-about-video]');
    var videoLabel = root.querySelector('[data-about-video-label]');
    var videoIcon = root.querySelector('[data-about-video-icon]');
    var introLayers = [
      videoButton,
      intro.querySelector('.firefly-about-hero__text'),
      intro.querySelector('h1')
    ].filter(Boolean);
    var stageLayerGroups = stages.map(function(stage) {
      return [
        stage.querySelector('.firefly-about-hero__eyebrow'),
        stage.querySelector('.firefly-about-hero__message')
      ].filter(Boolean);
    });

    if (videoButton && videoLabel && videoIcon && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var videoEntrance = gsap.timeline({
        paused: true,
        defaults: { force3D: true }
      });

      videoEntrance
        .addLabel('rush-in')
        .fromTo(videoLabel, {
          x: -130,
          autoAlpha: 0
        }, {
          x: 0,
          autoAlpha: 1,
          duration: 0.68,
          ease: 'back.out(1.9)',
          immediateRender: false
        }, 'rush-in')
        .fromTo(videoIcon, {
          x: 100,
          scale: 0.45,
          rotation: 24,
          autoAlpha: 0
        }, {
          x: 0,
          scale: 1,
          rotation: 0,
          autoAlpha: 1,
          duration: 0.68,
          ease: 'back.out(2.2)',
          immediateRender: false
        }, 'rush-in');

      videoButton.addEventListener('mouseenter', function() {
        videoEntrance.restart();
      });

      videoButton.addEventListener('mouseleave', function() {
        videoEntrance.pause(0);
        gsap.set([videoLabel, videoIcon], { clearProps: 'transform,opacity,visibility' });
      });
    }

    var media = gsap.matchMedia();

    media.add({ desktop: '(min-width: 768px)', mobile: '(max-width: 767px)' }, function(context) {
      var revealDistance = parseFloat(root.dataset[context.conditions.desktop ? 'desktopReveal' : 'mobileReveal']) || (context.conditions.desktop ? 320 : 180);
      if (context.conditions.desktop) {
        revealDistance = Math.max(revealDistance, canvas.offsetHeight - scene.clientHeight);
      }
      var initialOffsetValue = context.conditions.desktop
        ? root.dataset.desktopInitialOffset
        : root.dataset.mobileInitialOffset;
      var initialOffset = Math.min(
        parseFloat(initialOffsetValue) || 0,
        Math.max(0, revealDistance - 1)
      );
      var stageDistance = parseFloat(root.dataset.stageDistance) || 700;
      var introTransitionDistance = introLayers.length ? (context.conditions.desktop ? 420 : 300) : 0;
      var finalHoldDistance = stages.length ? (context.conditions.desktop ? 500 : 350) : 0;
      var finalHoldDuration = context.conditions.desktop ? 1 : 0.7;
      var introExitAt = 0.68;
      var firstStageEnterAt = 1.5;
      var totalDistance =
        Math.max(0, revealDistance - initialOffset) +
        introTransitionDistance +
        Math.max(1, stages.length) * stageDistance +
        finalHoldDistance;

      gsap.set(canvas, { y: -initialOffset, force3D: true });
      gsap.set(intro, { autoAlpha: 1, y: 0, force3D: true });
      gsap.set(introLayers, { autoAlpha: 1, y: 0, force3D: true });
      gsap.set(stages, { autoAlpha: 1, y: 0, force3D: true });
      stageLayerGroups.forEach(function(layers) {
        gsap.set(layers, { autoAlpha: 0, y: 42, force3D: true });
      });

      var firstStageLayers = stageLayerGroups[0] || [];
      var introTransitionComplete = false;
      var firstStageScrollReady = false;
      var firstStageEntranceActive = false;
      var firstStageEntrance = gsap.timeline({
        paused: true,
        defaults: { force3D: true }
      });

      if (firstStageLayers.length) {
        firstStageEntrance.to(firstStageLayers, {
          autoAlpha: 1,
          y: 0,
          duration: 0.34,
          stagger: 0.16,
          ease: 'power2.out',
          overwrite: 'auto'
        });
      }

      var syncFirstStageEntrance = function() {
        var shouldBeActive = introTransitionComplete && firstStageScrollReady;
        if (shouldBeActive === firstStageEntranceActive) return;
        firstStageEntranceActive = shouldBeActive;

        if (shouldBeActive) {
          firstStageEntrance.play();
        } else {
          firstStageEntrance.reverse();
        }
      };

      var introTransition = gsap.timeline({
        paused: true,
        defaults: { force3D: true },
        onComplete: function() {
          introTransitionComplete = true;
          syncFirstStageEntrance();
        },
        onReverseComplete: function() {
          introTransitionComplete = false;
          syncFirstStageEntrance();
        }
      });

      introTransition.to(introLayers, {
        autoAlpha: 0,
        y: -24,
        duration: 0.42,
        stagger: 0.18,
        ease: 'power2.in',
        overwrite: 'auto'
      });

      var timeline = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          id: 'firefly-about-hero-' + rootIndex,
          trigger: root,
          start: 'top top',
          end: '+=' + Math.round(totalDistance),
          scrub: 0.45,
          pin: scene,
          pinSpacing: true,
          anticipatePin: 1,
          invalidateOnRefresh: true
        }
      });

      timeline
        .fromTo(canvas, { y: -initialOffset }, { y: -revealDistance, duration: 1, immediateRender: false }, 0);

      stages.forEach(function(stage, index) {
        var layers = stageLayerGroups[index];
        var position = firstStageEnterAt + index * 1.15;
        var entranceDuration = 0.26;
        var entranceStagger = 0.14;
        var entranceEnd = entranceDuration + Math.max(0, layers.length - 1) * entranceStagger;

        if (index > 0) {
          timeline.to(layers, {
            autoAlpha: 1,
            y: 0,
            duration: entranceDuration,
            stagger: entranceStagger,
            ease: 'power2.out'
          }, position);
        }

        if (index < stages.length - 1) {
          timeline.to(stage, {
            autoAlpha: 0,
            y: -32,
            duration: 0.28,
            ease: 'power2.in'
          }, position + 0.82);
        } else {
          timeline.to(stage, { autoAlpha: 1, y: 0, duration: 0.55 }, position + entranceEnd);
          timeline.to(stage, {
            autoAlpha: 1,
            y: 0,
            duration: finalHoldDuration
          }, position + entranceEnd + 0.55);
        }
      });

      var introTransitionActive = false;
      timeline.eventCallback('onUpdate', function() {
        var shouldBeActive = timeline.time() >= introExitAt;
        var shouldShowFirstStage = timeline.time() >= firstStageEnterAt;

        if (shouldShowFirstStage !== firstStageScrollReady) {
          firstStageScrollReady = shouldShowFirstStage;
          syncFirstStageEntrance();
        }

        if (shouldBeActive === introTransitionActive) return;
        introTransitionActive = shouldBeActive;

        if (shouldBeActive) {
          introTransition.play();
        } else {
          introTransition.reverse();
        }
      });

      return function() {
        firstStageEntrance.kill();
        introTransition.kill();
        timeline.scrollTrigger && timeline.scrollTrigger.kill();
        timeline.kill();
      };
    });
  });

  var refresh = function() {
    ScrollTrigger.refresh();
  };

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
  window.addEventListener('load', refresh, { once: true });

})();
